import { UtilizationBasedOnDTO } from '../types/dto/utilization-based-on.dto';
import { UtilizationBasedOn } from '../types/utilization-based-on';

/**
 * Maps API utilization mode DTO to internal UtilizationBasedOn enum.
 * Handles the conversion from wire format to application domain model.
 */
export const mapUtilizationBasedOnFromDTO = (mode: UtilizationBasedOnDTO): UtilizationBasedOn => {
  switch (mode) {
    case UtilizationBasedOnDTO.TOTAL_CAPACITY:
      return UtilizationBasedOn.TotalCapacity;
    case UtilizationBasedOnDTO.BILLABLE_CAPACITY:
      return UtilizationBasedOn.BillableCapacity;

    default:
      return UtilizationBasedOn.TotalCapacity;
  }
};

/**
 * Maps internal UtilizationBasedOn enum to API utilization mode DTO.
 * Handles the conversion from application domain model to wire format.
 */
export const mapUtilizationBasedOnToDTO = (mode: UtilizationBasedOn): UtilizationBasedOnDTO => {
  switch (mode) {
    case UtilizationBasedOn.TotalCapacity:
      return UtilizationBasedOnDTO.TOTAL_CAPACITY;
    case UtilizationBasedOn.BillableCapacity:
      return UtilizationBasedOnDTO.BILLABLE_CAPACITY;
    default:
      return UtilizationBasedOnDTO.TOTAL_CAPACITY;
  }
};
